/**
 * Helper class to check if it is running on mobile or web
 */

const detectMobileType = () =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent)
    ? 'iPhone'
    : /Android/i.test(navigator.userAgent)
    ? 'Android'
    : 'Desktop';

const onMobile = () => {
  return detectMobileType() !== 'Desktop';
};
export default onMobile;
